import { noop } from 'lodash-es';
import styled from 'styled-components';

interface FjAvatarStyle {
  backgroundColor: string;
  color: string;
  fontSize: string;
  fontWeight: number;
}

interface FjAvatarProps {
  boxSize: number;
  initials?: React.ReactNode;
  selectable?: boolean;
  className?: string;
  callback?: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  fjAvatarStyle?: FjAvatarStyle;
}

const FjAvatar = styled.button.attrs<FjAvatarProps>(({ onClick: onClickProp, ...props }) => ({
  type: 'button',
  tabIndex: props.selectable ? 0 : -1,
  className: props.className || 'fj-avatar',
  children: props.initials,
  onClick: (evt: React.MouseEvent<HTMLButtonElement>) =>
    props.selectable && (props.callback || onClickProp || noop)(evt),
  fjAvatarStyle: props.fjAvatarStyle || {
    backgroundColor: 'rgb(20, 104, 120)',
    color: '#fff',
    fontSize: '21px',
    fontWeight: 600,
  },
  selectable: props.selectable || false,
}))`
  justify-content: center;
  align-items: center;
  padding: 0;
  border: 0;
  text-transform: uppercase;
  height: ${(props) => props.boxSize}px;
  width: ${(props) => props.boxSize}px;
  cursor: ${(props) => (props.selectable ? 'pointer' : 'default')};
  background-color: ${(props) => props.fjAvatarStyle!.backgroundColor};
  color: ${(props) => props.fjAvatarStyle!.color};
  font-size: ${(props) => props.fjAvatarStyle!.fontSize};

  &:focus {
    border: 0;
  }
`;

export default FjAvatar;
